import { render } from "./AddFacilityConfig.vue?vue&type=template&id=eb981760&scoped=true&ts=true"
import script from "./AddFacilityConfig.vue?vue&type=script&lang=ts"
export * from "./AddFacilityConfig.vue?vue&type=script&lang=ts"

import "./AddFacilityConfig.vue?vue&type=style&index=0&id=eb981760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb981760"]])

export default __exports__